import {useEffect} from "react";

const useEnterKey = (onEnter, enabled = true, preventDefault = false) => {
    useEffect(() => {
        if (!enabled) return;

        const handleKeyDown = e => {
            if (e.key !== "Enter" && e.key !== "NumpadEnter") return;
            if (preventDefault) {
                e.preventDefault();
            }
            onEnter();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [onEnter, enabled, preventDefault]);
};

export default useEnterKey;
